import createReactComponent from '../createReactComponent';
export default createReactComponent('device-speaker', 'IconDeviceSpeaker', [
  [
    'path',
    {
      d: 'M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M12 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-1' }],
  ['path', { d: 'M12 7l0 .01', key: 'svg-2' }],
]);
